export default "/images/open-close-icon.svg";